var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.OzListRow,{attrs:{"dark-mode":_vm.darkMode,"separator":_vm.separator,"clickable":_vm.clickable,"disabled":_vm.disabled,"aria-label":_setup.wallLabel},on:{"click":_setup.select},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c(_setup.ImageThumbnail,{class:[
        'rounded-lg rounded-br-2xl rtl:rounded-br-lg rtl:rounded-bl-2xl',
        'mr-4 rtl:mr-0 rtl:ml-4',
        'shrink-0',
        _setup.isFaded && 'opacity-30',
      ],attrs:{"src":_vm.wall.thumbnail.url,"placeholder-color-value":_setup.dominantColorAsRgb,"placeholder-color":'random',"fallback-to-placeholder":true,"original-image-width":_vm.wall.thumbnail.width || 36,"original-image-height":_vm.wall.thumbnail.height || 36,"width":36,"process-image":true,"aspect-ratio":1}})]},proxy:true},(_vm.xMore)?{key:"right",fn:function(){return [_c(_setup.OzPlainButton,{class:['ms-1 -me-1'],attrs:{"color-scheme":_setup.OzPlainButtonColorScheme.SecondaryIcon,"size-preset":_setup.OzPlainButtonSizePreset.H28px,"data-testid":_setup.title,"aria-label":_setup.__('More')},on:{"click":function($event){$event.stopPropagation();return _setup.more.apply(null, arguments)}}},[_c(_setup.OzIcon,{attrs:{"size":20,"name":"more_vertical"}})],1)]},proxy:true}:null],null,true)},[_vm._v(" "),_c('div',{staticClass:"my-2 relative overflow-hidden"},[_c('div',{class:[
        'text-17-21',
        'font-semibold',
        _vm.invertColors
          ? {
              'text-dark-text-100': _vm.darkMode === true && !_setup.isFaded,
              'text-dark-text-300': _vm.darkMode === true && _setup.isFaded,
              'text-light-text-100': _vm.darkMode === false && !_setup.isFaded,
              'text-light-text-300': _vm.darkMode === false && _setup.isFaded,
              'dark:text-dark-text-100 text-light-text-100': _vm.darkMode === 'auto' && !_setup.isFaded,
              'text-dark-text-300 dark:text-light-text-300': _vm.darkMode === 'auto' && _setup.isFaded,
            }
          : {
              'text-light-text-100': _vm.darkMode === true && !_setup.isFaded,
              'text-light-text-300': _vm.darkMode === true && _setup.isFaded,
              'text-dark-text-100': _vm.darkMode === false && !_setup.isFaded,
              'text-dark-text-300': _vm.darkMode === false && _setup.isFaded,
              'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto' && !_setup.isFaded,
              'text-dark-text-300 dark:text-light-text-300': _vm.darkMode === 'auto' && _setup.isFaded,
            },
        'truncate',
      ]},[_vm._v("\n      "+_vm._s(_setup.title)+"\n    ")]),_vm._v(" "),_c('div',{class:[
        'text-body-extra-small',
        'flex',
        'leading-4',
        _vm.invertColors
          ? {
              'text-dark-text-100': _vm.darkMode === true,
              'text-light-text-100': _vm.darkMode === false,
              'dark:text-dark-text-100 text-light-text-100': _vm.darkMode === 'auto',
            }
          : {
              'text-light-text-200': _vm.darkMode === true,
              'text-dark-text-200': _vm.darkMode === false,
              'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
            },
      ]},[_c('span',{staticClass:"truncate"},[_vm._v(_vm._s(_setup.accountDisplayName))]),_vm._v(" "),_c('span',{class:[
          _vm.invertColors
            ? {
                'text-dark-text-300': _vm.darkMode === true,
                'text-light-text-300': _vm.darkMode === false,
                'text-light-text-300 dark:text-dark-text-300': _vm.darkMode === 'auto',
              }
            : {
                'text-light-text-300': _vm.darkMode === true,
                'text-dark-text-300': _vm.darkMode === false,
                'text-dark-text-300 dark:text-light-text-300': _vm.darkMode === 'auto',
              },
        ]},[_vm._v(" • ")]),_vm._v(" "),(_setup.xRelativeTimestamp)?_c(_setup.OzRelativeTime,{attrs:{"datetime":_setup.date,"dateformat":"short"}}):_c('span',{class:[_setup.wallDeletingSoon && 'text-danger-100']},[_vm._v(_vm._s(_setup.daysTillDeletedDisplay))]),_vm._v(" "),(_setup.xTemplate)?_c(_setup.OzBadge,{staticClass:"h-4 ms-3 bg-teal-600 text-light-text-100",attrs:{"text":_setup.__('Template'),"size-preset":_setup.OzBadgeSizePreset.Tiny,"color-scheme":_setup.OzBadgeColorScheme.Bare}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }